/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var breakPointPC = 1279;
	var breakPointSP = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// loadContents
	// ----- BOTH
	// ------------------------------------------------------------------------
	var loadContents = function loadContents() {
	
	  var loadContents = document.querySelector('.idx-Load');
	  var mainContents = document.querySelector('.idx-Main');
	  var campaignContents = document.querySelector('.idx-Campaign');
	
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      loadContents.classList.add('is-Loaded');
	      mainContents.classList.add('is-Loaded');
	      campaignContents.classList.add('is-Loaded');
	    }, 2000);
	    setTimeout(function () {
	      loadContents.parentNode.removeChild(loadContents);
	    }, 6000);
	  });
	};
	
	// ------------------------------------------------------------------------
	// setSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var setSlider = function setSlider() {
	
	  var sliderImageWidth = void 0;
	  var sliderExtraWidth = void 0;
	  var sliderObject = void 0;
	
	  if (windowWidth > breakPointPC) {
	    sliderImageWidth = windowWidth * 0.5;
	    sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
	  } else if (windowWidth <= breakPointPC && windowWidth > breakPointSP) {
	    sliderImageWidth = windowWidth * 0.75;
	    sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
	  } else {
	    sliderImageWidth = windowWidth * 0.78125;
	    sliderExtraWidth = (windowWidth - sliderImageWidth) / 2;
	  }
	
	  sliderObject = $('.idx-Main_Slider_List').slick({
	    speed: 600,
	    autoplay: true,
	    autoplaySpeed: 4000,
	    infinite: true,
	    dots: true,
	    arrows: true,
	    slidesToShow: 1,
	    centerMode: true,
	    centerPadding: sliderExtraWidth + 'px'
	  });
	
	  window.addEventListener('load', function () {
	    $('.idx-Main_Slider_List').addClass('slick-ready');
	  });
	
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    var sliderResizeWidth = void 0;
	    var sliderExtraResizeWidth = void 0;
	    if (resizeWidth > breakPointPC) {
	      sliderResizeWidth = resizeWidth * 0.5;
	      sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
	    } else if (resizeWidth <= breakPointPC && resizeWidth > breakPointSP) {
	      sliderResizeWidth = resizeWidth * 0.75;
	      sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
	    } else {
	      sliderResizeWidth = resizeWidth * 0.78125;
	      sliderExtraResizeWidth = (resizeWidth - sliderResizeWidth) / 2;
	    }
	    sliderObject[0].slick.options.centerPadding = sliderExtraResizeWidth + 'px';
	  });
	};
	
	// ------------------------------------------------------------------------
	// animateFade
	// ----- BOTH
	// ------------------------------------------------------------------------
	var animateFade = function animateFade() {
	
	  $(window).on('scroll', function () {
	    $('.anime-Fade').each(function () {
	      var imagePosition = $(this).offset().top;
	      var scrollVolume = $(window).scrollTop();
	      var windowWidth = $(window).width();
	      var windowHeight = $(window).height();
	      if (windowWidth > breakPointSP) {
	        if (scrollVolume > imagePosition - windowHeight + windowHeight / 3.25) {
	          $(this).addClass('anime-Fade-On');
	        }
	      } else {
	        if (scrollVolume > imagePosition - windowHeight + windowHeight / 4) {
	          $(this).addClass('anime-Fade-On');
	        }
	      }
	    });
	  });
	};
	
	(function () {
	  loadContents();
	  setSlider();
	  animateFade();
	  (0, _module.visibleButton)();
	  (0, _module.anchorLink)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPointPC = 1279;
	var breakPointSP = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// visibleButton
	// ----- BOTH
	// ------------------------------------------------------------------------
	var visibleButton = function visibleButton() {
	  var targetButton = document.querySelector('.sw-Top');
	  var targetHeight = 100;
	  window.addEventListener('scroll', function () {
	    var scrollHeight = window.pageYOffset;
	    if (scrollHeight > targetHeight) {
	      targetButton.classList.remove('is-Hidden');
	    } else {
	      targetButton.classList.add('is-Hidden');
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.visibleButton = visibleButton;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js